import { Head } from '@unhead/react';

export const FreshchatScript = () => {
    return (
        <Head>
            <style>
                {`
                    /* Prevent Freshchat frame from creating a scrollbar during initial load */
                    #fc_frame {
                        position: fixed;
                        bottom: 1px;
                        left: 1px;
                    }
                `}
            </style>
            <script>
                {`
                    window.fcWidgetMessengerConfig = {
                        locale: 'en',
                        config: {
                            headerProperty: {
                                hideChatButton: true,
                            },
                        },
                    };
                `}
            </script>
            <script async src="//eu.fw-cdn.com/12695234/696125.js" {...({ chat: 'true' } as any)} />
        </Head>
    );
};
